module.exports = __webpack_public_path__ + "static/media/Lost-deal.dd9f717d.svg";